import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  TableBody,
  Drawer,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import FormulationPostVisit from './FormulationPostVisit';

const StatusMoods = [
  'NOT OUR PATIENT', 'ALREADY HAS AN APPOINTMENT', 'OPEN', 'INSURANCE CHANGED', 'OTHER PCP', 'PENDING', 'REFUSED'
]

const CodingDetails = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState(modificar.Comments || []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openReferralForm, setOpenReferralForm] = useState(false);
  const [newComment, setNewComment] = useState('');
  const timestamp = new Date().toLocaleString(); 

  const [form, setForm] = useState({
    PostVisitID: modificar.PostVisitID || '',
    TimeStamp: modificar.TimeStamp || '',
    MemberName: modificar.MemberName || '',
    MemberPhoneNumber: modificar.MemberPhoneNumber || '',
    MemberMobileNumber: modificar.MemberMobileNumber || '',
    Location: modificar.Location || '',
    PcpName: modificar.PcpName || '',
    DateOfService: modificar.DateOfService || '',
    Comments: modificar.Comments || '',
    Staff: modificar.Staff || '',
    DidThePatientAnswer:modificar.DidThePatientAnswer || '',
    AppointmentType: modificar.AppointmentType || '',
    HowWasYourVisitWithTheDoctor: modificar.HowWasYourVisitWithTheDoctor || '',
    WereYouPrescribedAnyMedocatopms: modificar.WereYouPrescribedAnyMedocatopms || '',
    DidTheDoctorOrderLabsToBeDone: modificar.DidTheDoctorOrderLabsToBeDone || ''
  });

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: form.PCPFullName }];
    setComments(updatedComments);
    handleChange('Comments', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };

  const SaveNewSystemicBilling  = (newSystemicBilling) => {
    console.log(newSystemicBilling);
    setComments(newSystemicBilling.Comments)
    setForm((newSystemicBilling));
    onSave(newSystemicBilling);
  }

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Post Visit</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setOpenReferralForm(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Did the Patient Answer?:</strong> {form.DidThePatientAnswer}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Name:</strong> {modificar.MemberName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>DOB:</strong> {modificar.DOB}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {modificar.MemberPhoneNumber}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Location:</strong> {modificar.Location}</Typography></Grid>
            </Grid>
        </Grid>
      </Paper>
      
      <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
          <Box width={650} p={3}>
              <FormulationPostVisit
                  modificar={ modificar?? [] }
                  open={openReferralForm}
                  onClose={() => setOpenReferralForm(false)}
                  onSave={(newReferral) => {
                      SaveNewSystemicBilling(newReferral);
                      setOpenReferralForm(false);
                  }}
              />
          </Box>
      </Drawer>
    </Container>
  );
};

export default CodingDetails;
